<template>
    <div class="col-md-12">
        <div class="field pull-right">
            <div class="control">
                <button class="btn btn-success" title="Add New Product" type="button" @click="openModal">
                    <span class="icon"><i class="fas fa-plus"></i></span><span>Add New Product</span>
                </button>
            </div>
        </div>
        <br>
        <br>
        <hr>
        <table v-cloak v-if="product.id" class="table is-narrow is-striped is-fullwidth">
            <thead>
                <tr>
                    <th>Category</th>
                    <th>Product</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td><a :href="product.route" v-html="product.category"></a>
                        <input v-model="product.id" :name="'product_id'" type="hidden">
                    </td>
                    <td>
                        <span v-html="product.name"></span>
                    </td>
                </tr>
            </tbody>
        </table>
        <div v-cloak v-else>
            <span>No Product Found. </span><a href="javascript:" @click="openModal">Add One Now</a>
        </div>
        <div id="searchModal" class="modal fade">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button aria-hidden="true" class="close" data-dismiss="modal"
                            type="button">&times;
                        </button>
                        <h4 class="modal-title">Add Product</h4>
                    </div>

                    <div class="modal-body">
                        <div id="search-input">
                            <div class="input-group col-md-12">
                                <input v-model="searchTerm" class="form-control" min="1" name="searchTerm" placeholder="Enter Search Term" type="text" @keydown.enter.prevent="search">
                                <span class="input-group-btn">
                                <button :disabled="searching" class="btn btn-info btn-lg" type="button" @click="search">
                                    <i class="voyager-search"></i>
                                </button>
                            </span>
                            </div>
                        </div>
                        <div v-if="!searching">
                            <hr>
                            <table v-cloak v-if="searchResults.length" class="table is-narrow is-striped is-fullwidth">
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th>Product</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in searchResults">
                                        <td><span v-html="item.category"></span></td>
                                        <td><span v-html="item.name"></span></td>
                                        <td style="padding: 2px;">
                                            <button :class="{disabled: isAdded(item.id)}" :disabled="isAdded(item.id)" class="btn btn-success" title="Add Product" type="button" @click="add(item)">
                                                <span class="icon"><i class="fas fa-plus"></i></span>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-else>
                                <span v-html="resultsText"></span>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button class="btn btn-default" data-dismiss="modal" type="button" @click="closeModal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ProductRelations',
        props: {
            data: {
                type: Object,
                default() {
                    return {};
                }
            },
            searchUrl: {
                type: String
            }
        },
        data() {
            return {
                searchTerm: '',
                searchResults: [],
                searching: false,
                resultsText: 'No Results',
                product: this.data
            };
        },
        methods: {
            openModal() {
                $('#searchModal').modal('show');
            },
            closeModal() {
                $('#searchModal').modal('hide');
                this.searchResults = [];
                this.searchTerm = '';
                this.resultsText = 'No Results';
            },
            add(item) {
                let newModel = {
                    id: item.id,
                    name: item.name,
                    category: item.category,
                    route: item.route
                };

                this.product = structuredClone(newModel);
                this.$nextTick(() => {
                    this.$forceUpdate();
                });
            },
            search() {
                let that = this;

                if(!that.searching) {
                    that.searchResults = [];
                    that.searching = true;

                    axios.get(that.searchUrl + '/' + that.searchTerm).then(function(response) {
                        if(response.data) {
                            that.searchResults = response.data;
                        }
                        that.searching = false;
                        that.resultsText = 'No Results';
                    });
                }
            },
            isAdded(id) {
                return parseInt(this.product.id) === parseInt(id);
            }
        }
    };
</script>
